import {
  GET_PROFILE_SECTION,
  GET_PROFILE_SECTION_SUCCESS,
  GET_PROFILE_SECTION_FAILURE,
} from 'store/doctorProfileSection/doctorProfileSectionAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const profileSectionDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE_SECTION:
      return { ...state, loading: true };
    case GET_PROFILE_SECTION_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PROFILE_SECTION_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default profileSectionDataReducer;
